import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import SlidePreview from './SlidePreview';
import { Header, HeaderLabel, HeaderButton } from '../../../styles';
import { Label, TextArea } from './styles';
import { SlideTextData } from '../../../../../../containers/Editor/utils/indesignEditor/editableSliders/getData';

interface TextEditorProps {
	previewUrl: string;
	previewWidth: number;
	previewHeight: number;
	shouldScalePreview?: boolean;
	isBackgroundSlide?: boolean;
	text: SlideTextData;
	slidesLength: number;
	onConfirm: (text: SlideTextData) => void;
	onCancel: () => void;
}

const getTextForTextArea = (text: string): string => (
	text.replace(/\<br \/\>/g, '\n')
);

const getTextForSlide = (text: string): string => (
	text.replace(/\n\r?/g, '<br />')
);

const TextEditor = ({
	previewUrl,
	previewWidth,
	previewHeight,
	shouldScalePreview,
	isBackgroundSlide,
	text: initialText,
	slidesLength,
	onConfirm,
	onCancel,
}: TextEditorProps) => {
	const [textValue, setTextValue] = React.useState(initialText.value);

	React.useEffect(() => {
		setTextValue(initialText.value);
	}, [initialText.value]);

	const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		setTextValue(e.target.value);
	};

	const handleConfirm = () => {
		const valueToSave = getTextForSlide(textValue);

		if (valueToSave !== initialText.value) {
			onConfirm({
				...initialText,
				value: getTextForSlide(textValue),
			});
		}

		onCancel();
	};

	return (
		<div>
			<Header>
				<HeaderButton onClick={onCancel}>
					<Translate value="messages.cancel" />
				</HeaderButton>
				<HeaderLabel value="messages.edit_text" />
				<HeaderButton onClick={handleConfirm}>
					<Translate value="messages.ok" />
				</HeaderButton>
			</Header>
			<SlidePreview
				url={previewUrl}
				width={previewWidth}
				height={previewHeight}
				shouldImageScale={shouldScalePreview}
				isBackgroundSlide={isBackgroundSlide}
				textValue={getTextForSlide(textValue)}
				textFontFamily={initialText.font.family}
				textSize={initialText.font.size}
				textColor={initialText.font.color}
				textBackgroundColor={initialText.font.backgroundColor}
				textShadowColor={initialText.font.shadowColor}
				textPosition={initialText.position}
				slidesLength={slidesLength}
			/>
			<Label value="messages.enter_your_text" />
			<TextArea
				value={getTextForTextArea(textValue)}
				onChange={handleTextAreaChange}
			/>
		</div>
	);
};

export default TextEditor;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SliderManager/Slide/TextEditor/index.tsx